import { render, staticRenderFns } from "./Card3.vue?vue&type=template&id=c53f4dd4&scoped=true&"
import script from "./Card3.vue?vue&type=script&lang=js&"
export * from "./Card3.vue?vue&type=script&lang=js&"
import style0 from "./Card3.vue?vue&type=style&index=0&id=c53f4dd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c53f4dd4",
  null
  
)

export default component.exports